import {  createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface UserSlice {
  uid: String | null;
  code: String | null;
  status: 'null' | 'loading' | 'active';
}

const initialState: UserSlice = {
  uid: null,
  code: null,
  status: 'null'
};

export const UserSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<String | null>) => {
        state.uid = action.payload;
    },
    setCode: (state, action: PayloadAction<String | null>) => {
        state.code = action.payload;
    },
    },
  },
);

export const { setUser, setCode } = UserSlice.actions;
export const selectUserID = (state: RootState) => state.user.uid;
export const selectUserStatus = (state: RootState) => state.user.status;


export default UserSlice.reducer;
